@let product = 'shared:forceUpdate.agentTitle' | i18next: { product: (data?.productKey | i18next) };
<mbs-modal
  #modal
  [isCustomModal]="true"
  [title]="actionKey | i18next">
  <ng-container modal-body>
    <p class="mb-3">{{ textKey | i18next: { count: versionsCount, product } }}</p>
    <ul [class]="showAutoUpdateWarning ? 'mb-3' : 'mb-0'">
      @for (entry of entries; track entry.buildType) {
        @let releaseNotesLink = data.showReleaseNotes && entry.releaseNotesPath ? (entry.releaseNotesPath | helpLink) : null;
        <li [attr.data-e2e]="elementSelectors.name.row">
          @if (entry.buildName) {
            {{ entry.buildName }}
          } @else {
            {{ entry.osKey | i18next }}:
            @if (entry.currentVersion) {
              v{{ entry.currentVersion }} &rarr;
            }
            <a
              target="_blank"
              [attr.class]="releaseNotesLink ? 'fw-semibold' : null"
              [attr.data-e2e]="elementSelectors.name.version"
              [attr.href]="releaseNotesLink"
              >v{{ entry.version }}</a
            >
          }
        </li>
      }
    </ul>
    @if (showAutoUpdateWarning) {
      <p
        class="mb-0"
        [attr.data-e2e]="elementSelectors.name.autoUpdateWarning">
        {{ 'shared:forceUpdate.actionConfirm.autoUpdateWarning' | i18next: { count: versionsCount } }}
      </p>
    }
  </ng-container>

  <ng-container modalFooter>
    <mbs-button
      type="primary"
      [attr.data-e2e]="elementSelectors.name.confirmButton"
      (click)="confirm()">
      {{ actionKey | i18next }}
    </mbs-button>
    <mbs-button
      type="secondary"
      [attr.data-e2e]="elementSelectors.name.cancelButton"
      (click)="cancel()">
      {{ 'shared:buttons.cancel' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
